import React, { forwardRef, useRef } from 'react';
import { cn } from './cn';
import './ScrollStrip.css';

/** Horizontal overflow with native touch/trackpad scrolling and mouse dragging. */
const ScrollStrip = forwardRef(function ScrollStrip({ children, className, variant, ...props }, ref) {
  const drag = useRef(null);
  return (
    <div
      {...props}
      ref={ref}
      className={cn(
        'overflow-x-auto overscroll-x-contain select-none',
        variant === 'filters' ? 'bun-scroll-strip--filters pb-2' : '[scrollbar-width:thin]',
        className
      )}
      onPointerDown={(event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag.current = { x: event.clientX, scrollLeft: event.currentTarget.scrollLeft, pressed: true, moved: false };
      }}
      onPointerMove={(event) => {
        const gesture = drag.current;
        if (!gesture?.pressed) return;
        if (!event.buttons) { drag.current = null; return; }
        const distance = event.clientX - gesture.x;
        if (!gesture.moved && Math.abs(distance) < 5) return;
        gesture.moved = true;
        event.preventDefault();
        event.currentTarget.setPointerCapture(event.pointerId);
        event.currentTarget.scrollLeft = gesture.scrollLeft - distance;
      }}
      onPointerUp={() => {
        const gesture = drag.current;
        if (!gesture) return;
        gesture.pressed = false;
        setTimeout(() => { if (drag.current === gesture) drag.current = null; }, 0);
      }}
      onPointerCancel={() => { drag.current = null; }}
      onClickCapture={(event) => {
        if (!drag.current?.moved) return;
        event.preventDefault();
        event.stopPropagation();
        drag.current = null;
      }}
    >
      {children}
    </div>
  );
});

export default ScrollStrip;
